; (function () {
  if (window.__luteCartInterceptInstalled) return
  window.__luteCartInterceptInstalled = true

  var ADD_RE = /\/cart\/add(?:\.js|\.json)?\/?$/
  var MUTATION_RE = /\/cart\/(?:add|change|update|clear)(?:\.js|\.json)?\/?$/

  var _lastCartUpdatedAt = null

  function _getCartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/)
    if (!m) return null
    return decodeURIComponent(m[1]).split('?')[0]
  }

  // Storefront API 查询 cart.updatedAt，无需 access token（同源自动认证）
  async function fetchCartUpdatedAt() {
    var token = _getCartToken()
    if (!token) return Promise.resolve(null)
    var cartId = 'gid://shopify/Cart/' + token
    try {
      const res = await _origFetch('/api/2026-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: 'query($id:ID!){cart(id:$id){updatedAt}}',
          variables: { id: cartId },
        }),
      })
      const json = res.ok ? await res.json() : null
      return (json && json.data && json.data.cart && json.data.cart.updatedAt) || null
    } catch {
      return null
    }
  }

  async function fetchCart() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
    try {
      const res = await _origFetch(root + 'cart.js', { credentials: 'same-origin' })
      return res.ok ? res.json() : null
    } catch {
      return null
    }
  }

  async function dispatch(isAdd, extraDetail) {
    const updatedAt = await fetchCartUpdatedAt()
    if (updatedAt && updatedAt === _lastCartUpdatedAt) return
    _lastCartUpdatedAt = updatedAt
    var cartPromise = fetchCart()
    document.dispatchEvent(
      new CustomEvent('lute:cart-mutation', {
        bubbles: true,
        detail: Object.assign({ isAdd: isAdd, cart: cartPromise }, extraDetail),
      })
    )
  }

  // ── fetch / XHR 拦截 ────────────────────────────────────────────────────────
  var _origFetch = window.fetch

  function installIntercepts() {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || ''
      var method = ((init && init.method) || (typeof input === 'object' && input.method) || 'GET').toUpperCase()
      var isMut = method === 'POST' && MUTATION_RE.test(url)
      var isAdd = method === 'POST' && ADD_RE.test(url)

      var promise = _origFetch.apply(this, arguments)

      if (isMut) {
        promise.then(function (res) {
          if (res.ok) dispatch(isAdd)
        }).catch(function () { })
      }

      return promise
    }

    var _XHR = XMLHttpRequest.prototype
    var _origOpen = _XHR.open
    var _origSend = _XHR.send
    _XHR.open = function (method, url) {
      this._luteMutMethod = method
      this._luteMutUrl = url
      return _origOpen.apply(this, arguments)
    }

    _XHR.send = function (body) {
      var method = (this._luteMutMethod || '').toUpperCase()
      var url = this._luteMutUrl || ''
      var isMut = method === 'POST' && MUTATION_RE.test(url)
      var isAdd = method === 'POST' && ADD_RE.test(url)

      if (isMut) {
        var self = this
        this.addEventListener('readystatechange', function () {
          if (self.readyState === 4 && self.status >= 200 && self.status < 400) {
            dispatch(isAdd)
          }
        })
      }

      return _origSend.apply(this, arguments)
    }
  }

  installIntercepts()

  // Shopify.actions.updateCart 触发此事件，等 promise 完成后 dispatch
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.promise) {
      event.promise.then(function () {
        dispatch(event.action === 'add', event.detail)
      }).catch(function () {})
    }
  })
})()
